<div [ngClass]="{'mox-ui-page-container': claim.isMox()}">
    <div class="prev-bar">
        <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><i class="fas fa-arrow-left"></i>&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}}&nbsp;</a>
        <a (click)="back()" *ngIf="claim.isMox()" class="back-chevron"></a>
    </div>
    <div class="col-12">
        <h5>{{ 'claimSection.generalLabels.whatHappened' | translate}}</h5>
        <p>{{ 'claimSection.other.detailIncident.description' | translate }} </p>
    </div>
    <BR>
    <div class="row col-12">
        <div class="col-xl-9 col-lg-12" [ngClass]="{'mox-ui-full-width': claim.isMox()}">
            <form>
                <div class="form-group">
                    <qnect-ui #TRAVEL_OTH_01_INCIDENT_DATE [fieldId]="'TRAVEL_OTH_01_INCIDENT_DATE'" [formGroup]="otherForm" name="otherDateOfIncident"></qnect-ui>
                </div>
                <div class="form-group" *ngIf="!claim.getClaimTravel().getGBAPlanType()">
                    <qnect-ui #TRAVEL_OTH_02_COUNTRY_DAMAGE_OCCURRED [fieldId]="'TRAVEL_OTH_02_COUNTRY_DAMAGE_OCCURRED'" [formGroup]="otherForm" name="otherCountryDamageOccurred"></qnect-ui>
                </div>
                <div class="form-group" *ngIf="claim.getClaimTravel().getGBAPlanType()">
                    <qnect-ui #GBA_PLACE_OF_LOSS [fieldId]="'GBA_PLACE_OF_LOSS'" [formGroup]="otherForm" name="placeOfLoss"></qnect-ui>
                </div>
            </form>
        </div>
        <div class="col-xl-3 col-lg-12">
        </div>
    </div>
    <div class="submit-bar">
        <abandon-button></abandon-button>
        <a href="javascript:;" (click)="showModal()" [hidden]="claim.isMox()" class="Tertiary">{{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
        <button (click)="goToNext()" class="btn new-btn btn-primary float-right">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<i class="fas fa-arrow-right" ></i></button>
    </div>
    <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>
